var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_5569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4656 6.69381L13.3219 4.83756C14.1078 4.12124 15.1395 3.73529 16.2026 3.7599C17.2657 3.78451 18.2784 4.2178 19.0303 4.96972C19.7822 5.72164 20.2155 6.73438 20.2401 7.79748C20.2648 8.86057 19.8788 9.89227 19.1625 10.6782L16.5094 13.3219C16.127 13.7057 15.6726 14.0103 15.1723 14.2181C14.6719 14.4259 14.1355 14.5328 13.5937 14.5328C13.052 14.5328 12.5155 14.4259 12.0152 14.2181C11.5149 14.0103 11.0605 13.7057 10.6781 13.3219",
    stroke: "#978E74",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5344 17.3058L10.6781 19.1621C9.89221 19.8784 8.86051 20.2643 7.79741 20.2397C6.73432 20.2151 5.72158 19.7818 4.96966 19.0299C4.21774 18.278 3.78445 17.2652 3.75984 16.2021C3.73522 15.1391 4.12118 14.1074 4.8375 13.3214L7.49063 10.6777C7.873 10.2939 8.32738 9.98935 8.82772 9.78156C9.32805 9.57376 9.86449 9.4668 10.4063 9.4668C10.948 9.4668 11.4845 9.57376 11.9848 9.78156C12.4851 9.98935 12.9395 10.2939 13.3219 10.6777",
    stroke: "#978E74",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_5569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.ec7dfe0acea3bb994ee488d3a17664e4.svg";
export { ForwardRef as ReactComponent };